/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A user as found by the organizer user search (`GET /users/search`, #145).
 * 
 * Only what a team picker needs: no e-mail, no organizations, no account details.
 * @export
 * @interface UserSearchRead
 */
export interface UserSearchRead {
    /**
     * 
     * @type {string}
     * @memberof UserSearchRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserSearchRead
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserSearchRead
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSearchRead
     */
    last_name?: string | null;
}

/**
 * Check if a given object implements the UserSearchRead interface.
 */
export function instanceOfUserSearchRead(value: object): value is UserSearchRead {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function UserSearchReadFromJSON(json: any): UserSearchRead {
    return UserSearchReadFromJSONTyped(json, false);
}

export function UserSearchReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSearchRead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'username': json['username'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function UserSearchReadToJSON(json: any): UserSearchRead {
    return UserSearchReadToJSONTyped(json, false);
}

export function UserSearchReadToJSONTyped(value?: UserSearchRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'username': value['username'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

